
<template>
  <div id="app" class="container-fluid">
    <div class="row">
      <div
        class="col-12 nav flex-x-between"
        :class="{ onScroll: !view.topOfPage }"
      >
        <img src="image/logo.png" class="logo" alt="" />
      </div>
      <div
        class="col-12"
        style="padding: 30px 10px; padding-top: 100px !important"
      >
        <h5 class="mb-3">အမေးများသောမေးခွန်းများ</h5>
        <div class="faq-list mb-3">
          <accordion>
            <accordion-item>
              <template slot="accordion-trigger">
                <h5>ဝန်ဆောင်ခ ဘယ်လောက်ပါလဲ?</h5>
              </template>
              <template slot="accordion-content">
                <p>
                  50000MMK အောက် 15%
                  <br /><br />
                  100000MMK အောက် 10%
                  <br /><br />
                  100000MMK အထက် 5% (unlimited amount)
                </p>
              </template>
            </accordion-item>

            <accordion-item>
              <template slot="accordion-trigger">
                <h5>ဘယ် app တွေရလဲ?</h5>
              </template>
              <template slot="accordion-content">
                <p>
                  1688, TMall, TaoBao, Pin Dou Dou, Alibaba app များမှ Link and
                  Item screenshot လေးပို့ပေးရပါမယ်ရှင့်
                </p>
              </template>
            </accordion-item>

            <accordion-item>
              <template slot="accordion-trigger">
                <h5>ဘယ်လိုတာဝန်ယူလဲ?</h5>
              </template>
              <template slot="accordion-content">
                <p>
                  တာဝန်ယူမှုအနေဖြင့် အောက်ပါစည်းကမ်း ချက်လေးတွေ
                  သေချာဖတ်ပေးပါရှင်🌸<br /><br />
                  (1) တရုတ်ဆိုင်ဘက်က မှားပို့လာသော
                  ဆိုဒ်၊အရောင်၊တဇိုင်းမှားပစည်းများကို ပြန်လဲလို့မရ။
                  (ဘာကြောင့်လဲဆိုလက်ရှိ Covide-19 ရောဂါကြောင့် တရုတ်ဘက်ကို
                  ရေသန့်ဗူးတစ်ဗူးကအစ ပြန်ပို့လို့မရသောကြောင့်ပါရှင်)
                  <br /><br />
                  (2) လူကြီးမင်းတို့မှာယူနေသော မှန်တင်ခုံ၊ ကုတင်၊ ဖိနပ်စဉ်၊
                  အဝတ်စဉ် စသော ပြန်လည် တပ်ဆင်ရသော၊ ဂျပ်လိုက်လာသောပစ္စည်းများကို
                  မင်မင်တို့ စစ်ဆေးလို့ အဆင်မပြေပါ အနာပါခြင်း
                  အရောင်မှားခြင်းတို့ တာဝန်ယူလို့ မရပါ။
                  <br /><br />
                  (3) ရောဂါကာလကြောင့် ကားအဆင့်အဆင့်ချိန်းရသောကြောင့်
                  ကွဲတက်၊ကွဲလွယ်သော၊ ဖိလို့မရသော ပစည်းများ မမှာပေးပါ၊
                  လူကြီးမင်းတို့မှာချင်ပါကမင်မင်တို့ တာဝန်ယူပေးမည် မဟုတ်ပါ။
                  <br /><br />
                  (4) ဝန်ဆောင်ခ 5%တည်း နှင့် မင်မင်တို့ ရန်ကုန်ရုံးအထိတာဝန်ယူ
                  ဆောင်ရွက်ပေးထားပါသည်ရှင်
                  <br /><br />
                  (5) ရန်ကုန်မှ လူကြီးမင်းများ လာယူလို့ရပါသည် သို့ delivery
                  အပ်ပေးပါသည် တခြားမြို့များသို့ပို့ဆောင်ရာတွင်လူကြီးမင်းတို့
                  ကြိုက်နှစ်သက်သည့် ကားဂိတ်ကိုပို့ပေးပါသည်ရှင်
                  <br /><br />
                  (6) ကားဂိတ်ပို့ပီးလျှင်မင်မင်တို့ တာဝန်ပီးဆုံးပီး
                  ဖြစ်ပါသည်!<br />
                  ကားနောက်ကျခြင်း၊ တန်ဆာခစျေးများခြင်း၊ ကားဂိတ်တွင်
                  မိုးရေစိုခြင်း၊ အိတ်ပေါက်ပြဲခြင်း နှင့် လမ်းမှာ ဆွဲချခံရခြင်း
                  စသောအမျိုးမျိုးကြောင်ဖြစ်ပေါ် တတ်သောအရာများများကို ကားဂိတ်သာ
                  တာဝန်ယူပေးပါမည်ရှင်<br />
                  မင်မင်တို့ဘက်က တက်နိုင်သလောက် ကားခစျေးဆစ်ပေးခြင်း၊<br />
                  လူကြီးမင်းဆီသို့ အဆင်ပြေပြေရောက် ရှိအောင်
                  စကားပြောပေးခြင်းဖြင့်ကူညီဆောင် ရွက်ပေးပါသည်ရှင်<br /><br />
                  (7) လူကြီးမင်းတို့ ကားဂိတ်တွင် ပစည်းထုတ်ပါက အိတ်၊ဂျပ်ဖာ
                  ပေါက်ပြဲခြင်းရှိမရှိ ၊ အိတ်၊ဂျပ်ဖာ
                  ပေါက်ပြဲမူရှိပါက(အိတ်ပေါ်မှာ ၊ဂျပ်ဖာ ပေါ်မှာ ပြည့်မပြည့်
                  ပစည်းမထုတ်မီ ကားဂိတ်မှာ အိတ်အရေအတွက် တခါတည်း ရေတွက်ပေးပါရှင်
                  <br />
                  လူကြီးမင်းတို့ပစည်းလက်ခံရရှိသည့်နေ့မှ(4)ရက်အတွင်း
                  မင်မင်တို့ပို့ပေးလိုက်သည့်ပစ္စည်းများ File Tracking Code
                  update လုပ်ပေးထားတာမို့ သေချာတိုက်စစ်ပေးပါရန်
                  <br />
                  အရေတွက် လိုတာ သို့ ပစ္စည်းမပို့လာတာရှိ လူကြီးမင်းမှာယူသော
                  တရုတ်ဆိုင်ကို စကားပြောပေးခြင်း၊ Refund
                  တောင်းပေးခြင်းများလုပ်ဆောင်ပေးပါမည်ရှင်
                  Refundတောင်းလို့ရလာခဲ့လျှင် လူကြီးမင်းစိတ်တိုင်းကျ ပြန်အမ်းငွေ
                  ရယူတာ သို့ ပစ္စည်းထပ်မှာတာ လုပ်ဆောင်နိုင်ပါသည်ရှင်<br />
                  လူကြီးမင်းတို့ပစ္စည်းလက်ခံပြီး (4)ရက်ထက်ကျော်ပြီးမှ
                  ပြန်ပြောလာပါက မင်မင်တို့ တာဝန်ဆောင်ရွက်ပေးမည် မဟုတ်တော့ပါရှင်
                  <br /><br />
                  မင်တို့ Service လေးနှင့် လက်တွဲပေးလို့
                  ကျေးဇူးအများကြီးတင်ပါတယ်ရှင်😍
                </p>
              </template>
            </accordion-item>

            <!-- <accordion-item>
              <template slot="accordion-trigger">
                <h5>ကုန်းလမ်း(1) အကြောင်းပြောပြပါ</h5>
              </template>
              <template slot="accordion-content">
                <p>
                  ! Kg ပေါင်းမချိန်ပေးသေးပါရှင့်<br />
                  <br />
                  Link တစ်ခုကို Tracking code တစ်ခုထွက်ပါတယ်<br />
                  <br />

                  China Warehouse မှ ရန်ကုန်မြို့အထိ
                  <br /><br />

                  1 Tracking code (ဖိနပ်ဖာဆိုဒ်ထိသာ / 1kg less than or equal) =
                  15Yuan<br /><br />

                  ဖိနပ်ဖာထက်ကြီးသော ကုန်ပွများကို CBM တိုင်းဖြတ်ပါမည်<br /><br />

                  အလေးချိန်ရှိသော tracking code များကို<br />
                  1kg = 15Yuan နှုန်းဖြင့်ချိန်ပေးပါမည်ရှင့်🤍
                  <br /><br />
                  ကြာချိန်ကတော့ China Warehouse ကနေကားထွက်ပီး 3weeks
                  ခန့်မှန်း<br /><br />
                  (လူကြီးမင်းမှာသော တရုတ်ဆိုင်ကပို့တာ စောတယ်ဆို
                  ကားထွက်တာလည်းမှိဆို စောစောရောက်တတ်ပါတယ်ရှင့် /
                  တကယ်လို့ဆိုင်ကပို့တာနောက်ကျရင်နောက်ကားသယ်ရက်
                  ကြာချိန်အနည်းငယ်စောင့်ပေးရပါတယ်ရှင့် / )<br /><br />
                  Note - ဆိုင်တစ်ဆိုင်ထဲမှာ ပစ္စည်းအများမှာသူများ နှင့်
                  ဆိုင်ဖွင့်ထားသူများအတွက် ပိုအဆင်ပြေနိုင်ပါသည်ရှင့်<br />
                </p>
              </template>
            </accordion-item> -->

            <accordion-item>
              <template slot="accordion-trigger">
                <h5>ကုန်းလမ်း အကြောင်းပြောပြပါ</h5>
              </template>
              <template slot="accordion-content">
                <p>
                  ➤ Cargo Fees<br />

                  🏠 Yangon အထိ<br /><br />
                  📌1Kg to 50Kg<br />
                  1Kg = 12¥<br /><br />

                  📌50 to 100Kg<br />
                  1Kg = 11.5¥<br /><br />

                  📌100Kg above<br />
                  1Kg = 11¥<br /><br />

                  1CBM = 1500¥<br /><br />

                  ___________________________<br /><br />

                  🏠 Lashio အထိ<br /><br />

                  📌1Kg to 50Kg<br />
                  1Kg = 9¥<br /><br />

                  📌50 to 100Kg<br />
                  1Kg = 8.5¥<br /><br />

                  📌100Kg above<br />
                  1Kg = 8¥<br /><br />

                  1CBM = 1300¥<br /><br />

                  ပစ္စည်းတော်တော်များအားလုံးKgပေါင်းချိန်ပေးပါတယ်ရှင့်🙆🏻‍♀️🤍<br /><br />

                  ▸ ဖာပွ/ကုန်ပွများကို CBMဖြင့်တိုင်းပါတယ်ရှင့်<br />
                </p>
              </template>
            </accordion-item>
          </accordion>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Accordion from "./components/accordion";
import AccordionItem from "./components/accordion-item";

export default {
  name: "App",
  components: {
    Accordion,
    AccordionItem,
  },
  mounted() {
    const loader = document.querySelector(".page-loader");
    loader.className += " hidden";
    setTimeout(() => {
      loader.className += " display_none";
    }, 1000);
  },
  data() {
    return {
      view: {
        topOfPage: true,
      },
      expanded: false,
    };
  },
  beforeMount() {
    window.addEventListener("scroll", this.onScroll);
  },
  methods: {
    onScroll() {
      if (window.pageYOffset > 0) {
        if (this.view.topOfPage) this.view.topOfPage = false;
      } else {
        if (!this.view.topOfPage) this.view.topOfPage = true;
      }
    },
  },
};
</script>

<style>
.bg-svg {
  position: fixed;
  bottom: -50px;
  right: 0px;
  z-index: -1;
}
.column:not(:last-child) .card.card.not-expanded {
  border-bottom: 1px solid rgb(0, 0, 0, 0.05) !important;
}
a {
  text-decoration: none !important;
}

.faq-list {
  background: linear-gradient(160deg, #6d53a524, #e6b2ca4f);
  padding: 10px;
  border-radius: 15px;
}

.nav {
  background: rgba(0, 0, 0, 0);
  position: fixed !important;
  top: 5px;
  left: 10px;
  width: calc(100vw - 20px) !important;
  border-radius: 10px;
  right: 10px;
  z-index: 100;
  transition: all 0.3s ease-in-out;
}
.logo {
  width: 150px;
  transition: all 0.3s ease-in-out;
}

.nav.onScroll {
  background: rgba(255, 255, 255);
  box-shadow: 0px 4px 25px -4px rgb(0, 0, 0, 0.15);
}
.nav.onScroll img {
  width: 130px;
}
.particles {
  width: 100vw;
  height: 100vh;
  position: fixed;
  top: 0px;
  left: 0px;
}
</style>
